import React, { useEffect, useState } from "react";
import { getAllMatchesAPI } from "../service/AuthService";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import PasswordCheckViewMore from "./components/PasswordCheckViewMore";
import { useSelector } from "react-redux";

export default function InPlayList({ completeGame }) {

  const [matches, setMatches] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector((state) => state.account.userData);
  const [showModalViewMore, setShowModalViewMore] = useState(false);
  const location = useLocation();
  const getAllMatches = async (page) => {
    const { response } = await getAllMatchesAPI(page, completeGame);
    setMatches(response.content);
    setTotalPages(response.totalPages);
    setTotalElements(response.totalElements);
    setSize(response.size);
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [completeGame, location.pathname]);

  // ✅ Fetch when page changes
  useEffect(() => {
    getAllMatches(currentPage);
  }, [currentPage, completeGame]);

  const displayedMatches = matches.filter(
    (item) => item?.eventId != null && Number(item.eventId) >= 0
  );

  return (
    <>
      {showModalViewMore && (
        <div
          style={{
            height: "auto",
            width: "50% !important",
            marginLeft: "25%",
          }}
        >
          <PasswordCheckViewMore
            show={showModalViewMore}
            setShow={setShowModalViewMore}
          />{" "}
        </div>
      )}
      <div className="content-wrapper" style={{ minHeight: "1263.44px" }}>
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Games</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Inplay</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* /.card */}
                <div className="card">
                  <form action="#" method="post" id="demoForm">
                    <div className="card-header">
                      <h2 className="card-title">Sport Details</h2>
                    </div>
                    {/* /.card-header */}
                    <div className="card-body">
                      <table
                        id="example1"
                        className="table table-bordered table-striped "
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>SNo</th>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Date Time</th>
                            <th>Match Type</th>
                            {completeGame && <>
                              <th>Won By</th>
                              <th>Declare</th>
                            </>}

                            <th>My Share P/L</th>
                            <th>Total P/L</th>


                          </tr>
                        </thead>
                        <tbody>
                          {displayedMatches.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div align="center">
                                  <div className="btn-group">
                                    <button
                                      type="button"
                                      className="btn  btn-outline-primary dropdown-toggle dropdown-hover dropdown-icon"
                                      data-toggle="dropdown"
                                    >
                                      <span className="sr-only">
                                        Toggle Dropdown
                                      </span>
                                    </button>
                                    <div
                                      className="dropdown-menu"
                                      role="menu"
                                    >
                                      {!completeGame &&
                                        <a
                                          className="dropdown-item btn"
                                          onClick={() =>
                                            navigate(
                                              `/game/matchPosition/${item.id
                                              }`, {
                                              state: { match: item }
                                            }
                                            )
                                          }
                                        >
                                          Match & Session Position
                                          {" "}
                                        </a>}
                                      {completeGame &&
                                        <a
                                          className="dropdown-item btn"
                                          onClick={() => {
                                            navigate(
                                              `/game/sessionPlusMinusSelect/${item?.id
                                              }`,
                                              {
                                                state: { match: item },
                                              }
                                            );
                                          }}
                                        >
                                          Match & Session Plus Minus
                                        </a>
                                      }
                                      {!completeGame &&
                                        <a
                                          className="dropdown-item btn"
                                          onClick={() => {
                                            navigate(
                                              `/game/sessionPlusMinusSelect/${item?.id
                                              }`,
                                              {
                                                state: { match: item },
                                              }
                                            );
                                          }}
                                        >
                                          Session Plus Minus
                                        </a>}
                                      <a
                                        className="dropdown-item btn"
                                        onClick={() => {
                                          navigate(
                                            `/game/displayMatchSession/${item?.id
                                            }`,
                                            {
                                              state: { match: item },
                                            }
                                          );
                                        }}
                                      >
                                        Display Match &amp; Session Bets{" "}
                                      </a>
                                      <a
                                        className="dropdown-item btn"
                                        onClick={() => {
                                          navigate(
                                            `/game/i/${item?.id
                                            }/viewMatchReport`,
                                            {
                                              state: { match: item },
                                            }
                                          );
                                        }}
                                      >
                                        Display Match Bets{" "}
                                      </a>
                                      <a
                                        onClick={() => {
                                          navigate(
                                            `/game/i/${item?.id
                                            }/viewSessionReport`,
                                            {
                                              state: { match: item },
                                            }
                                          );
                                        }}
                                        className="dropdown-item btn"
                                        href={`/game/i/${item?.id
                                          }/viewSessionReport`}
                                      >
                                        Display Session Bets{" "}
                                      </a>
                                      {userData?.userType == "SUPER_ADMIN" && (
                                        <span
                                          _ngcontent-ng-c2354748527=""
                                          className="dropdown-item btn"
                                          onClick={() => {
                                            setShowModalViewMore({
                                              matchId: item?.id,
                                            });
                                          }}>
                                          <i
                                            _ngcontent-ng-c2354748527=""
                                            className="icon-film"
                                          />{" "}
                                          View More Bets
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td>{index + 1}</td>
                              <td>{item?.eventId}</td>
                              <td>{item?.eventName}</td>
                              <td>
                                <i className="fa fa-clock-o" />
                                &nbsp;{" "}
                                {moment(item?.eventDate).format("DD MMM HH:mm A")}
                              </td>

                              <td>{item?.sport}</td>
                              {completeGame && <>
                                <td>{item?.wonBy}</td>
                                <td>{item?.declared ? 'Yes' : 'No'}</td>
                              </>}

                              <td className={`${item?.profitLoss > 0 ? 'plus_value' : 'mainus_value'}`}>
                                {Number(item?.profitLoss)?.toFixed(2)}
                              </td>
                              <td className={`${item?.totalProfitLoss > 0 ? 'plus_value' : 'mainus_value'}`}>
                                {Number(item?.totalProfitLoss)?.toFixed(2)}
                              </td>

                            </tr>
                          ))}
                        </tbody>
                        <tfoot />
                      </table>
                      <div className="row mt-3">
                        <div className="col-sm-12 col-md-5">
                          <div
                            className="dataTables_info"
                            id="example1_info"
                            role="status"
                            aria-live="polite"
                          >
                            Showing &nbsp;
                            {currentPage * size + 1} to{" "}
                            {currentPage * size + size > totalElements
                              ? totalElements
                              : currentPage * size + size}{" "}
                            of {totalElements} entries
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-7">
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="example1_paginate"
                          >
                            <ul className="pagination justify-content-end align-items-center">
                              {/* Previous */}
                              <li
                                className={`page-item ${currentPage === 0 ? "disabled" : ""
                                  }`}
                              >
                                <button
                                  type="button"
                                  className="page-link"
                                  onClick={() => {
                                    if (currentPage > 0) {
                                      setCurrentPage(currentPage - 1);
                                    }
                                  }}
                                  disabled={currentPage === 0}
                                >
                                  Previous
                                </button>
                              </li>

                              {/* Current Page */}
                              <li className="page-item active">
                                <span className="page-link">
                                  {currentPage + 1} / {totalPages}
                                </span>
                              </li>

                              {/* Next */}
                              <li
                                className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""
                                  }`}
                              >
                                <button
                                  type="button"
                                  className="page-link"
                                  onClick={() => {
                                    if (currentPage < totalPages - 1) {
                                      setCurrentPage(currentPage + 1);
                                    }
                                  }}
                                  disabled={currentPage === totalPages - 1}
                                >
                                  Next
                                </button>
                              </li>
                            </ul>

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
